var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.$store.state.pageLoding),expression:"$store.state.pageLoding"}],attrs:{"id":"app"}},[(_vm.$store.state.registry)?_c('router-view'):_vm._e(),(!_vm.$store.state.registry && !_vm.$store.state.pageLoding)?_c('guidance'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }